import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";

export default function Landing() {
  return (
    <Layout>
      <section className="avcp-grid-bg rounded-3xl border border-[var(--avcp-line)] bg-[var(--avcp-surface)] p-10 sm:p-16">
        <div className="max-w-3xl">
          <span className="avcp-pill ink">Workforce Partners</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05]">
            Lead Techs. Helpers.
            <span className="block text-[var(--avcp-primary)]">Projects booked in minutes.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[var(--avcp-ink-soft)] max-w-2xl">
            Workforce Partners connects AV integrators with independent Lead Technicians
            and the Helper Technicians who power their installs. Leads assemble their own
            crews. Clients book Leads plus a helper count. Technicians set their own rate,
            regions, skills, and availability.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link to="/signup" className="avcp-btn primary">Create an account</Link>
            <Link to="/signin" className="avcp-btn ghost">I already have an account</Link>
          </div>
        </div>
      </section>

      <section className="mt-10 grid sm:grid-cols-3 gap-5">
        {[
          {
            t: "Contractor independence",
            d: "Set your own rate, your own regions, your own availability. Decline any booking. No exclusivity.",
          },
          {
            t: "Lead-tech crew control",
            d: "Lead technicians pick their helpers from preferred lists or the marketplace — never assigned.",
          },
          {
            t: "Configurable economics",
            d: "Platform fees per hour are configurable by Super Admin. No hard-coded rates. Versioned snapshots.",
          },
        ].map((f) => (
          <div key={f.t} className="avcp-card p-6">
            <div className="text-sm font-semibold tracking-tight text-[var(--avcp-primary)]">
              {f.t}
            </div>
            <p className="mt-2 text-sm text-[var(--avcp-ink-soft)]">{f.d}</p>
          </div>
        ))}
      </section>
    </Layout>
  );
}
